import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { helperFunctions } from "../helper";
import { AgTechQueryParam, OdQueryParam } from "../enums";
import { ITreatmentInfoResponse, ITrialLocationTreatment } from "../models";
import { URLConfig } from "../network/urlStore";

export const getTreatmentInfo = (
  trialId?: string,
  queryParams?: {
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }[]
): Observable<ITreatmentInfoResponse> => {
  let url = URLConfig.getTreatmentInfoTrialMasterURL(trialId);
  if (queryParams?.length) {
    for (const param of queryParams) {
      if (param?.value?.length) {
        url = helperFunctions.addQueryParam(url, param.key, param.value);
      }
    }
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ITreatmentInfoResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching treatment info data", error);
      }
    );
  });
};

export const getTreatmentInfoNextPage = (
  nextPageUri: string
): Observable<ITreatmentInfoResponse> => {
  const url = URLConfig.getTreatmentInfoNextPageTrialMasterURL(nextPageUri);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res) => {
        if (res) {
          const trialResponse = res as unknown as ITreatmentInfoResponse;
          subscriber.next(trialResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations master data", error);
      }
    );
  });
};

export const getAllTreatmentInfo = (
  trialId?: string,
  queryParams?: {
    key: AgTechQueryParam  | OdQueryParam;
    value: string[];
  }[]
): Observable<ITrialLocationTreatment[]> => {
  let allTreatmentInfo: ITrialLocationTreatment[] = [];

  return new Observable((subscriber) => {
    const errorHandler = (error: any) => {
      subscriber.error(error);
      console.error("Error while fetching treatment info data", error);
    };

    const responseHandler = (response: ITreatmentInfoResponse) => {
      allTreatmentInfo = [
        ...allTreatmentInfo,
        ...(response.trialLocationTreatments || []),
      ];

      if (response.nextPageUri) {
        getTreatmentInfoNextPage(response.nextPageUri).subscribe({
          next: responseHandler,
          error: errorHandler,
          complete: () => {
            console.info("Completed fetching paginated treatment info");
          },
        });
      } else {
        subscriber.next(allTreatmentInfo);
        subscriber.complete();
      }
    };

    // Initial API call
    getTreatmentInfo(trialId, queryParams).subscribe({
      next: responseHandler,
      error: errorHandler,
      complete: () => {
        console.info("Initial treatment info fetch complete");
      },
    });
  });
};

export const getTrialTreatmentLength = (
  queryParams: {
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }[],
  trialId?: string
): Observable<number> => {
  let url = URLConfig.getTreatmentInfoTrialMasterURL(trialId);
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const getContentLengthForRepLevel = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.ObservationGetAllURL("observationBook");
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const getContentLengthForTreatmentInfo = (
  trialId?: string,
  queryParams?: {
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }[]
): Observable<number> => {
  let url = URLConfig.getTreatmentInfoTrialMasterURL(trialId);
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};
